module.exports = __webpack_public_path__ + "img/Alejandra Meléndez Márquez_Compras.714a0613.png";